import Alert from 'features/shared/alerts/components/Alert';
import DocumentTypeEnumDTO from 'features/shared/enums/dynamic/DocumentTypeEnumDTO';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  requiredDocuments: DocumentTypeEnumDTO[];
}

const RequiredDocumentsAlert = ({ requiredDocuments }: Props) => {
  // translations
  const tLabels = useTranslation("requirements\\requirements").t;

  // helpers
  const getMissingDocumentsText = () => {
    return requiredDocuments.map(x => x.documentTypeName).join(", ");
  }

  // render
  if (requiredDocuments.length > 0) {
    return (
      <Alert alertObj={{ alertType: "Info" }} closable>
        <span className="mr-1">
          {tLabels("requiredDocumentsAlert.message")}
        </span>
        <em className="d-inline-block">
          {getMissingDocumentsText()}
        </em>
      </Alert>
    )  
  } else {
    return null;
  }
}

export default RequiredDocumentsAlert;